import { css } from '@microsoft/fast-element';

export const ClosePopupStyles = css`
  .close-dialog {
    position: absolute;
    z-index: 3;

    --dialog-width: 280px;
    --dialog-height: none;

    top: 48%;
    left: calc(50% - var(--dialog-width) / 2);
  }

  .close-dialog::part(positioning-region) {
    justify-content: end;
    position: relative;
  }

  .close-dialog::part(control) {
    border: 1px solid var(--border-1);
  }

  .header {
    min-height: 15px;
    font-size: 14px;
    margin: 0;
    font-family: Roboto-Bold, 'Roboto Bold', Roboto, sans-serif;
  }

  .description {
    font-size: 12px;
    margin: 0;
    padding: 7px 0 1px;
    font-family: Roboto-Regular, Roboto, sans-serif;
    color: #c9c9c9;
  }

  .text-container {
    padding: 11px 0 0 10px;
  }

  .button-container {
    margin: 15px 0;
    display: flex;
    justify-content: space-around;
  }

  .cancel {
    width: 125px;
    height: 36px;
    padding: 0 16px;
    border-radius: 4px;
    border: 1px solid #7c909b;
    background-color: rgb(124 144 155 / 50%);
    box-sizing: border-box;
    font-family: Roboto-Medium, 'Roboto Medium', Roboto, sans-serif;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: normal;
  }

  .confirm {
    width: 125px;
    height: 36px;
    padding: 0 16px;
    border-radius: 4px;
    border: 1px solid;
    background-image: linear-gradient(
      -106.0664deg,
      rgb(116 230 74 / 50%) 0%,
      rgb(205 172 31 / 50%) 100%
    );
    box-sizing: border-box;
    font-family: Roboto-Medium, 'Roboto Medium', Roboto, sans-serif;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: normal;
  }

  zero-button::part(control) {
    border: none;
    box-shadow: none;
  }
`;
